import { ReportItem } from './report/report-item';
import './reports-page.scss';
import { FC, useEffect } from 'react';
import { ReportPreferences } from 'src/dtos/user-preferences.dto';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'src/utils/use-navigate';
import { ReportName } from '@src/utils/enums';

interface ReportListProps {
    reports: ReportPreferences[];
    hasExecutiveSummary?: boolean; // whether feature flag is on
}

export const ReportList: FC<ReportListProps> = ({ reports, hasExecutiveSummary }) => {
    const navigate = useNavigate();
    const reportType = useParams().reportType;

    useEffect(() => {

        if (!hasExecutiveSummary && !reports.length) return;

        const computeDefault = () => {
            if (hasExecutiveSummary) return ReportName.EXECUTIVE_SUMMARY;
            return reports[0]?.reportName;
        };

        const shouldSelectDefault = !reportType || (reports.length > 0 && !reports.some(r => r.reportName === reportType));
        if (shouldSelectDefault) {
            const def = computeDefault();
            if (def && def !== reportType) {
                selectReportType(def);
            }
        }
    }, [hasExecutiveSummary, reportType, reports]);

    const selectReportType = (reportType: string) => {
        navigate(reportType);
    };


    return <div className="reports-list" data-testid="reports-list" id={'reports-list'}>
        {reports.map((report) => (
            <ReportItem
                key={report.reportName}
                reportData={report}
                selectReport={selectReportType}
                isSelected={report.reportName === reportType}
            />
        ))}
    </div>;
};